import extendedFieldHooks from "ExtendedFields/selectorHooks";

/**
 * returns whether or not the title and icon should be editable
 * @returns {boolean}
 */
const useFieldIsEditable = () => {
  const [isCustom] = extendedFieldHooks.useSelectedIsCustom();
  const [isForGroup] = extendedFieldHooks.useIsForGroup();
  const [isForSignupItem] = extendedFieldHooks.useIsForSignupItem();
  const [isFromProfiles] = extendedFieldHooks.useSelectedIsFromProfiles();
  // Never edit title and icon for non-custom fields
  if (!isCustom) return false;

  // custom fields can always be edited by the groups UI.
  if (isForGroup) return true;

  // Signup item UI may not edit if the field is coming from profiles.
  if (isForSignupItem && isFromProfiles) return false;

  // If you made it this far, it's probably fine.
  return true;
};

export { useFieldIsEditable };
